import { useEffect, useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { designTypesEnum } from "../../../../../../Helpers/EnumHelper";
import { useDispatch, useSelector } from "react-redux";
import {
  setEntityModalInfo,
  switchFromNonVisibleToVisible,
  switchFromVisibleToNonVisible,
  updateReportSchemeState,
} from "../../Store";
import ApiHelper from "../../../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../../../Helpers/EnumHelper";
import Image from "react-bootstrap/Image";
import IconSvg from "../../../../../SharedComponents/IconSvg";

export default function ReportItemEntityListRow({ entity, itemName }) {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(entity.order);
  const [heightInputVal, setHeightInputVal] = useState(Number(entity.height));
  const visibleReportItemEntityList = useSelector((state) => state.reportScheme.visibleReportItemEntityList);

  useEffect(() => {
    setHeightInputVal(Number(entity.height));
  }, [entity.height]);

  const GetKeyByValue = (value) => {
    return Object.keys(designTypesEnum).find((key) => designTypesEnum[key] === value);
  };

  const ChangeOrder = () => {
    let val = parseInt(inputValue);
    if (val > visibleReportItemEntityList.length || val === entity.order || val <= 0)
      return setInputValue(entity.order);
    let newList = JSON.parse(JSON.stringify(visibleReportItemEntityList));
    newList = newList.filter((x) => x.order != entity.order);
    newList.forEach((x, i) => (x.order = i + 1));

    let firstHalf = [];
    let secondHalf = [];
    newList = JSON.parse(JSON.stringify(newList));
    newList.forEach((x, i) => {
      if (i + 1 < val) firstHalf.push(x);
      else {
        x.edited = true;
        secondHalf.push(x);
      }
    });
    entity = JSON.parse(JSON.stringify(entity));
    entity.edited = true;
    firstHalf.push(entity);

    firstHalf = firstHalf.concat(secondHalf);
    let resultList = JSON.parse(JSON.stringify(firstHalf));
    resultList.forEach((x, i) => {
      x.order = i + 1;
    });

    dispatch(updateReportSchemeState({ visibleReportItemEntityList: resultList }));
  };

  const ChangeEntityHeight = () => {
    let coppiedList = JSON.parse(JSON.stringify(visibleReportItemEntityList));

    coppiedList.forEach((x, i) => {
      if (x.order == entity.order) {
        x.defaultHeight = x.defaultHeight ? x.defaultHeight : x.height;
        x.height = heightInputVal;
      }
    });

    dispatch(updateReportSchemeState({ visibleReportItemEntityList: coppiedList }));
  };

  const ChangeIsVisible = (isVisible) => {
    if (isVisible === false) {
      dispatch(
        switchFromVisibleToNonVisible({
          entity: entity,
        })
      );
    } else {
      dispatch(
        switchFromNonVisibleToVisible({
          entity: entity,
        })
      );
    }
  };

  const deleteElement = () => {
    let newList = JSON.parse(JSON.stringify(visibleReportItemEntityList));

    newList.splice(entity.order - 1, 1);
    newList.forEach((entity, i) => {
      entity.order = i + 1;
    });
    dispatch(updateReportSchemeState({ visibleReportItemEntityList: newList }));
  };

  const DisplayHtmlContent = (item) => {
    switch (item.componentName) {
      case "EmptySpace":
        return <></>;

      case "MonoSpace":
        return (
          <Row>
            <Col>
              <div dangerouslySetInnerHTML={{ __html: item.monoSpaceHtml }} />
            </Col>
          </Row>
        );

      case "DualSpace":
        return (
          <Row>
            <Col>
              <div dangerouslySetInnerHTML={{ __html: item.leftSpaceHtml }} />
            </Col>
            <Col>
              <div dangerouslySetInnerHTML={{ __html: item.rightSpaceHtml }} />
            </Col>
          </Row>
        );

      case "ImageSpace":
        return (
          <Row>
            <Col>
              <div className="flex-center">
                <Image style={{ maxWidth: "100%" }} src={ApiHelper.cloudFrontURL + folderEnum.scheme + item.imageName} />
              </div>
            </Col>
          </Row>
        );

      default:
        return <></>;
    }
  };

  return (
    <Row style={{ width: "100%" }}>
      {entity.htmlEl ? (
        <Col xs="6" md="1" className={"align-content-center"}>
          <h6 className={"text-center"} style={{ color: "lightgray", fontSize: "14px" }}>
            HTML
          </h6>
          <h6 className={"text-center"}>{itemName}</h6>
        </Col>
      ) : (
        <Col xs="6" md="1">
          <h6 className={"text-center"} style={{ color: "lightgray", fontSize: "14px" }}>
            {entity.id}
          </h6>
          <h6 className={"text-center"}>{itemName}</h6>
          <h6 className={"text-center"} style={{ color: "lightgray", fontSize: "14px" }}>
            {GetKeyByValue(entity.designType)}
          </h6>
        </Col>
      )}

      <Col xs="6" md="4" className="flex-center">
        {entity.htmlEl ? (
          <div>{DisplayHtmlContent(entity)}</div>
        ) : (
          <h3
            className={"show-cursor darken-hover rounded p-1"}
            onClick={() => {
              dispatch(setEntityModalInfo({ isShown: true, entity: entity }));
            }}
          >
            {entity.name}
          </h3>
        )}
      </Col>

      <Col xs="6" md="1" className={"align-content-center"}></Col>
      <Col xs="6" md="3" className={"align-content-center"}>
        <Row>
          <Col>
            <InputGroup size="sm">
              <InputGroup.Text>
                <div className="report-item-change-order-button" onClick={() => ChangeEntityHeight()}>
                  Kaydet
                </div>
              </InputGroup.Text>
              <Form.Control
                size="sm"
                type="number"
                min="1"
                value={heightInputVal}
                onChange={(e) => setHeightInputVal(e.target.value)}
              />
            </InputGroup>
            <h6 className="flex-center" style={{ color: "lightgray", fontSize: "14px", paddingTop: "5px" }}>
              {entity.defaultHeight}
            </h6>
          </Col>
          {entity.htmlEl ? (
            <Col className={"align-content-center"}>
              <div className="report-item-delete-button" onClick={deleteElement}>
                <IconSvg icon="trash-can" fill="#fff" />
              </div>
            </Col>
          ) : (
            <Col className={"align-content-center"}>
              <h5 className={"text-center"}>{entity.scopeName}</h5>
              <h6 className={"text-center"} style={{ color: "lightgray" }}>
                {entity.subScopeName}
              </h6>
            </Col>
          )}
        </Row>
      </Col>
      <Col xs="6" md="1" className="flex-center">
        <h4
          style={{
            color: entity.orderedBefore && !entity.edited ? "green" : "red",
          }}
        >
          {entity.order}
        </h4>
      </Col>

      <Col xs="6" md="1">
        <div className="report-item-change-order-button" onClick={() => ChangeOrder()}>
          Değiştir
        </div>
        <Form.Control
          type="number"
          min="1"
          size="sm"
          value={inputValue}
          step="1"
          onChange={(e) => setInputValue(e.target.value)}
        />
      </Col>
      <Col xs="6" md="1" className={"align-content-center"}>
        <Row className={"justify-content-end"}>
          <Form.Check reverse>
            <Form.Check.Input
              onChange={(event) => {
                ChangeIsVisible(event.target.checked);
              }}
              defaultChecked={entity.isVisible}
              className={"rounded-circle p-3 m-0 show-cursor"}
            ></Form.Check.Input>
          </Form.Check>
        </Row>
      </Col>
    </Row>
  );
}
